export const styles = {
    dropDownBox: { width: { xs: "100%", sm: "50%" }, pr: { sm: 1, md: 2 }, mb: { sm: 2, md: 1 }, mt: { sm: 2, md: 1 } },
    textColor: 
        { "& .MuiOutlinedInput-root": { color: '#A1A1A1' } }
    ,
    fieldTextColor: 
    {  color: '#A1A1A1'  }
,
}